module.exports={
    "shower": {
        "kJ": 7042,
        "name": "10 minute shower",
        "info": "Assuming 100º F shower and 2 gal/minute on a 60º day",
        "reference": "",
        "asset": "assets/shower.png"
    },
    "microwave": {
        "kJ": 60000,
        "name": "1 minute of microwaving",
        "info": "Assuming 1,000 watt microwave",
        "reference": "",
        "asset": "assets/microwave.png"
    },
    "phone": {
        "kJ": 14,
        "name": "1 phone charge",
        "info": "For iPhone X battery (2716 mAh) from 0% to full battery with a 5.1V charger",
        "reference": "https://www.devicespecifications.com/en/model-battery/36ea45ae",
        "asset": "assets/smartphone.png"
    },
    "wood": {
        "kJ": 7280000,
        "name": "1 log of wood",
        "info": "Assuming a cubic meter of Red Oak (700kg) burned at 70% efficiency (10.4 MJ/kg)",
        "reference": "http://www.daviddarling.info/encyclopedia/W/AE_wood_heat_value_BTU.html",
        "asset": "assets/wood.png"
    },
    "batteries": {
        "kJ": 270000,
        "name": "1 Tesla battery",
        "info": "Assuming fully charged Tesla model S (no engine efficiency conversion)",
        "reference": "https://en.wikipedia.org/wiki/Tesla_Model_S",
        "asset": "assets/battery.png"
    },
    "coal": {
        "kJ": 10360,
        "name": "1 kg of coal",
        "info": "Assuming 35% conversion efficiency",
        "reference": "https://www.engineeringtoolbox.com/fuels-higher-calorific-values-d_169.html",
        "asset": "assets/coal.png"
    },
    "gasoline": {
        "kJ": 128000000,
        "name": "1 gallon of gasoline",
        "info": "Assuming 40% energy conversion (for an engine)",
        "reference": "https://www.engineeringtoolbox.com/fuels-higher-calorific-values-d_169.html",
        "asset": "assets/gasoline.png"
    }
}
